/* eslint-disable import/no-unused-modules */
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { StatusEnum } from "../../utility/enums/common";

/**
 * Reference for future:
 * Currently PreTaskConfig will be used for source of truth for processing and transforming the tasks.
 * Later on when we are getting a single API for getting all tasks, the UI won't need to do additional fetching for getting the status of each tasks.
 * The UI will get single JSON that contains tasks with FINAL status.
 *
 * Later on, PreTaskConfig will be removed, and we will only use the Task interface on UI.
 */

export interface PreTaskConfig {
  titleText: string; // Responsible for showing the flyout title || TODO: Rename it later to flyoutTitle after the refactor is done
  analyticsOnExpand?: string; // Responsible to send the analytic data when the flyout is showed
  statusEndpoint?: string; // Responsible for the endpoint url to get the current status of tasks.
  hideWhenError?: boolean; // Responsible to hide the tasks from UI when there is an error fetching API
  shouldOverrideStatus?: Record<string, StatusEnum>; // Responsible to override the status of tasks from BE (like I9 tasks)
  defaultStatus?: StatusEnum;
  hideOnConfig?: boolean;
  taskStatusName?: string; // TODO: Need to confirm later with AppConfig, are we using this field as key, or TaskName. Use only the field that we get from appConfig
  getTaskStatusByBBId?: boolean; // Responsible as a flag to get task status using blackbird endpoint
  checkBusinessLine?: boolean; // If true, do the business line checking and disabled the task.
  taskName: string; // Task name that used for internally for check task.
  icon?: string; // If supplied, show the icon on Task Card.
  duration?: number; // Responsible to showing how long it takes to complete the task. || TODO: Refactor to durationInMinutes after the refactor is done.
}

// This is the final dumb version of the task. || TODO: Remove the I prefix once the refactor is done to match with the current code style.
export interface ITask {
  flyoutTitle: string;
  analyticsOnExpand?: string;
  status: StatusEnum;
  taskName: string; // Will be used for identifier for the task
  icon?: string;
  durationInMinutes?: number;
  shouldOverrideStatus?: Record<string, StatusEnum>; // Needed in some component to overriding the status on TaskCard
  taskId?: string; // used to save the taskId from server for each tasks if needed (e.g: Zappos and New Hire Video)
  // isLoaded: boolean;
}

// TODO: Remove the I prefix once the refactor is done to match with the current code style.
export interface ITaskGroup {
  name: string;
  tasks: Array<ITask>;
  totalTasks: number;
  completedTasks: number;
  id: string;
}

export interface TaskState {
  taskGroups: ITaskGroup[];
}

export const initialState: TaskState = {
  taskGroups: [],
};

export const taskSlice = createSlice({
  name: "tasks",
  initialState,
  reducers: {
    setTasks: (state, action: PayloadAction<{ taskGroups: ITaskGroup[] }>) => {
      state.taskGroups = action.payload.taskGroups;
    },
  },
});

export const getTask = (state: RootState) => state.task;
export const { setTasks } = taskSlice.actions;
export default taskSlice.reducer;
